import React, { useState } from "react";
import AutoAssignTable from "./AutoAssignTable";

const AutoAssign = () => {
  const [canUpdate, setCanUpdate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);

  return (
    <div className="page-top-div">
      <span className="text-span">Badge Manager</span>
      <AutoAssignTable canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default AutoAssign;
